<template>
  <div class="modal-body-content">
    <div class="modal-body-list-box">
      <div class="search-box-in-title">
        <h2>{{ $t('device') }} {{ $t('list') }}</h2>
        <div>
          <input v-model="search" :placeholder="$t('insert_search_query')" />
          <!-- <button type="button" @click.stop="showSmallModal = true" class="action-button">{{ $t('create_new') }}</button> -->
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th :class="getIsMobile() ? 'w20p' : 'w10p'">
              {{ $t('image') }}
            </th>
            <th :class="getIsMobile() ? 'w40p' : 'w20p'" @click="toggleSort('device', 'device_id')">
              {{ $t('device_id') }}
              <span v-if="sortStates.device.find(col => col.id === 'device_id').order">
                <img v-if="sortStates.device.find(col => col.id === 'device_id').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th :class="getIsMobile() ? 'w40p' : 'w20p'" @click="toggleSort('device', 'device_name')">
              {{ $t('device') + " " + $t('name') }}
              <span v-if="sortStates.device.find(col => col.id === 'device_name').order">
                <img v-if="sortStates.device.find(col => col.id === 'device_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <!-- <th v-show="!getIsMobile()" class="w25p" @click="toggleSort('device', 'group_name')">
              {{ $t('group') }}
              <span v-if="sortStates.device.find(col => col.id === 'group_name').order">
                <img v-if="sortStates.device.find(col => col.id === 'group_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th> -->
            <th v-show="!getIsMobile()" class="w15p" @click="toggleSort('device', 'update_interval')">
              {{ $t('interval_time') }}
              <span v-if="sortStates.device.find(col => col.id === 'update_interval').order">
                <img v-if="sortStates.device.find(col => col.id === 'update_interval').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w10p" style="cursor: not-allowed;">{{ $t('manage') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="device in paginatedData" :key="device.device_id" :style="device?.is_deleted ? { background: '#EBEBEB' } : {}">
            <td :class="getIsMobile() ? 'w20p' : 'w10p'">
              <img :src="getDeviceImage(device.device_id)" style="height: 35px; margin: 0; padding: 0; vertical-align: middle;"/>
            </td>
            <td :title="device.device_id" :class="getIsMobile() ? 'w40p' : 'w20p'" @click.stop="editDevice(device)" style="text-align: left;">
              {{ device.device_id }}
            </td>
            <td :title="device.device_name" :class="getIsMobile() ? 'w40p' : 'w20p'" @click.stop="editDevice(device)" style="text-align: left;">
              {{ device.device_name }}
            </td>
            <!-- <td v-show="!getIsMobile()" :title="device.group_name" class="w25p" @click.stop="editDevice(device)">
              {{ device.group_name }}
            </td> -->
            <td v-show="!getIsMobile()" :title="device.update_interval / 1000 + ' ' + $t('second')" class="w15p" @click.stop="editDevice(device)">
              {{ device.update_interval / 1000 }} {{ $t('second') }}
            </td>
            <td v-show="!getIsMobile()" class="w10p" v-if="!device?.is_deleted">
              <img @click.stop="editDevice(device)" src="@/assets/images/edit.svg" :title="$t('modify')"/>
              <img @click.stop="deleteDevice(device.device_id)" src="@/assets/images/delete.svg" :title="$t('delete')"/>
            </td>
            <td v-show="!getIsMobile()" class="w10p" v-else>
              <img @click.stop="restoreDevice(device.device_id)" src="@/assets/images/restore.svg" :title="$t('restore')"/>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 페이지네이션 -->
      <div class="pagination-control">
        <div>
          <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
          <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
        </div>
        <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
        <div>
          <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
        </div>
      </div>
    </div>

    <!-- #region 장치 개별 관리 모달 -->
    <div v-show="showSmallModal" class="modal-body-content-modal-background">
      <div class="modal-body-content-modal">
        <div class="modal-body-edit-box">
          <div class="modal-body-edit-box-title">
            <h2>{{ isEditing ? $t('modify_device') : $t('add_device') }}</h2>
            <img src="@/assets/images/x_black.svg" @click="resetForm()"/>
          </div>
          <div class="modal-body-edit-box-content">
            <div class="modal-body-edit-box-content-main">
              <table>
                <tbody>
                  <tr>
                    <th>{{ $t('device') }} ID</th>
                    <td><input v-model="deviceId" :placeholder="$t('enter_your_device_id')" required :disabled="isEditing" /></td>
                  </tr>
                  <tr>
                    <th>{{ $t('device') }} {{ $t('name') }}</th>
                    <td><input v-model="deviceName" :placeholder="$t('enter_your_device_name')" required :disabled="isEditing" /></td>
                  </tr>
                  <tr>
                    <th style="height: 109px;">{{ $t('image') }}</th>
                    <td><ImageUploadPreview style="height: 100px;"/></td>
                  </tr>
                  <!-- <tr>
                    <th>{{ $t('group') }}</th>
                    <td>
                      <select id="groupId" v-model="groupId">
                        <option v-for="group in group_list" :key="group.group_id" :value="group.group_id">
                          {{ group.group_name }}
                        </option>
                      </select>
                    </td>
                  </tr> -->
                  <tr>
                    <th>{{ $t('interval_time') }} ({{ $t('second') }})</th>
                    <td><input v-model="intervalTime" id="intervalTime" placeholder="전송 주기를 입력하세요" required /></td>
                  </tr>
                </tbody>
              </table>
              <div class="button-group">
                <button type="button" @click.stop="resetForm()" class="cancel-button">{{ $t('cancel') }}</button>
                <button v-if="deviceId && nowSelectedDevice && !nowSelectedDevice.is_deleted" type="button" @click.stop="deleteDevice(deviceId)" class="delete-button">{{ $t('delete') }}</button>
                <button v-else-if="deviceId && nowSelectedDevice && nowSelectedDevice?.is_deleted" type="button" @click.stop="restoreDevice(deviceId)" class="retrieve-button">{{ $t('restore') }}</button>
                <button type="button" @click.stop="saveDevice(isEditing)" class="action-button">{{ $t('submit') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #endregion -->
  </div>
</template>
  
<script setup>
import { ref, onMounted, computed, nextTick, onUnmounted, watch } from 'vue';
import { SERVER_REQUEST, GET_SERVER_REQUEST, device_list, group_list, imageUrl } from '../utils/ServerConnect';
import { showNotification } from '@/utils/Notification';
import { loadingStore } from '@/utils/LoadingStore';
import { sortedDeviceList, sortStates, toggleSort } from '@/utils/SortUtility';
import ImageUploadPreview from '@/components/ImageUploadPreview.vue';
import { fetchDeviceImages, getDeviceImage, previewImage, previewImageFile } from '@/utils/ImageUtility';
import { getIsMobile } from '@/utils/GlobalUtility';
import { showSmallModal } from '@/utils/ModalUtility';

const deviceId = ref('');
const deviceName = ref('');
const groupId = ref('1');
const intervalTime = ref(30);
let isEditing = false;
const nowSelectedDevice = ref();

// API를 통해 장치정보 받아오기
const fetchDeviceData = async () => {
  loadingStore.showLoading();

  device_list.value = await GET_SERVER_REQUEST('device');
  group_list.value = await GET_SERVER_REQUEST('group');

  const mapGroup = new Map(group_list.value.map(group => [group.group_id, group.group_name]));
  device_list.value = device_list.value.map(device => ({
    ...device,
    group_name: mapGroup.get(device.group_id) || null
  }));

  loadingStore.hideLoading();
};

const saveDevice = async (check) => {
  if (!deviceId.value || !deviceName.value || !groupId.value) {
    showNotification('Enter information.', 'warn', 'top-center');
    return;
  }
  let upload_image = previewImage.value;
  if (previewImage.value === new URL('../assets/images/person.svg', import.meta.url).href) {
    upload_image = null;
  } else if (upload_image === imageUrl() + nowSelectedDevice.value.device_image) {
    upload_image = previewImage.value;
  } else {
    upload_image = previewImageFile.value
  }

  const formData = new FormData();
  formData.append("device_id", deviceId.value);
  formData.append("device_name", deviceName.value);
  formData.append("device_image", upload_image);
  formData.append("group_id", groupId.value);
  formData.append("update_interval", intervalTime.value * 1000);

  loadingStore.showLoading();
  await SERVER_REQUEST('device', check ? 'PUT' : 'POST', formData, false, null);
  fetchDeviceImages(); // 수정된 이미지 캐싱을 위함
  loadingStore.hideLoading();
  resetForm();
};

const deleteDevice = async (id) => {
  const totalData = {
    device_id: id
  }
  const jsonData = JSON.stringify(totalData);

  loadingStore.showLoading();
  await SERVER_REQUEST('device', 'DELETE', jsonData);
  loadingStore.hideLoading();
  resetForm();
};

const restoreDevice = async (id) => {
  const totalData = {
    device_id: id,
    undelete: true
  }
  const jsonData = JSON.stringify(totalData);

  loadingStore.showLoading();
  await SERVER_REQUEST('device', 'DELETE', jsonData);
  loadingStore.hideLoading();
  resetForm();
};

const editDevice = (device) => {
  nowSelectedDevice.value = device;
  showSmallModal.value = true;
  deviceId.value = device.device_id;
  deviceName.value = device.device_name;
  previewImage.value = device.device_image ? imageUrl() + device.device_image : new URL('../assets/images/person.svg', import.meta.url).href;
  groupId.value = device.group_id;
  intervalTime.value = device.update_interval / 1000;
  isEditing = true;
};

const resetForm = () => {
  nowSelectedDevice.value = null;
  showSmallModal.value = false;
  deviceId.value = '';
  deviceName.value = '';
  previewImage.value = new URL('../assets/images/person.svg', import.meta.url).href;
  groupId.value = '1';
  intervalTime.value = 30;
  isEditing = false;

  fetchDeviceData();
};

// Initialize map on component mount
onMounted(() => {
  nextTick(() => {
    previewImage.value = new URL('../assets/images/person.svg', import.meta.url).href;
    fetchDeviceData();
  });
  loadingStore.hideLoading();
});
onUnmounted(() => {
  previewImage.value = null;
});

const currentPage = ref(1);
const itemsPerPage = ref(10);
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(filteredList.value.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredList.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

const search = ref("");
const filteredList = computed(() => {
  const query = search.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedDeviceList.value.filter(device =>
  String(device.device_id).toLowerCase().includes(query) // ID로 검색
    || String(device.device_name).toLowerCase().includes(query) // 이름으로 검색
    || String(device.group_name).toLowerCase().includes(query) // 그룹으로 검색
    || String(device.update_interval).toLowerCase().includes(query) // 주기로 검색
  );
});

// 현재 보고있는 페이지를 전체 페이지수에 맞춰 자동으로 바꿔줌
watch(
  () => filteredList.value.length,
  () => {
    const newTotalPages = Math.ceil(filteredList.value.length / itemsPerPage.value);
    if (currentPage.value > newTotalPages) {
      currentPage.value = newTotalPages || 1; // 0일 때도 대비
    }
  }
);
</script>